import React from 'react';
import './app.scss';

const App = ({ children }: { children: any }) => <div className="app">{children}</div>;

export default App;
